import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPost } from '../utils/api';
import { useNotify } from '../components/NotificationComponent';
import { motion } from 'framer-motion'
import { UserContext } from '../context/UserContext';
import { LoadingComponent } from '../components';

export default function AccountPage() {
  const navigate = useNavigate();
  const { userInfo, setUserInfo, setUserMetaInfo } = useContext(UserContext)
  const [accountInfo, setAccountInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { notify } = useNotify()
  const userInfoApiFired = useRef()
  
  useEffect(() => {
    const fetchAccountInfo = async () => {
      if(!userInfoApiFired.current){
        userInfoApiFired.current = true;
        try {
          const res = await apiGet('user-info/');
          setAccountInfo(res);
          setLoading(false);
        } catch (err) {
          localStorage.removeItem('userInfo');
          sessionStorage.clear();
          setUserInfo(undefined)
          setUserMetaInfo({})
          navigate('/login')
          notify('Failed to fetch user info, redirecting to login page');
          setLoading(false);
        }
      }
    };
    
    fetchAccountInfo();
  }, []);

  
  if (loading) {
    return <div className="min-h-[85vh] flex flex-col justify-center items-center text-center py-10">
      <LoadingComponent className='border-blue-500 h-8 w-8'/>
      <p className='my-2'>Loading account info...</p>
    </div>;
  }

  const logoutHandler = () => {
    apiPost('logout/', {refresh : userInfo?.refresh}).then(res => {
      notify("You've been logged out successfully 👋")
      setTimeout(()=>{
        localStorage.removeItem('userInfo');
        sessionStorage.clear();
        setUserInfo(undefined)
        setUserMetaInfo({})
        navigate('/login')
      }, 2000)
    }).catch(err => {
      notify(err.response && err.response.data.detail ? err.response.data.detail : err.message)
    }).finally(()=>{
    })
  }

  return (
    <div className="max-w-2xl mx-auto py-20 px-4">
      <motion.section
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
      >
        <div className='flex justify-between items-center'>
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Account Details</h2>
          <h6 onClick={()=>logoutHandler()} className='text-red-600 cursor-pointer font-semibold'>Logout</h6>
        </div>
      </motion.section>
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay:0.2, duration:0.8  }}
        viewport={{ once: true }}
      >
        <div className="bg-white border shadow-[0_2px_15px_rgba(0,0,0,0.15)] rounded-md p-6 space-y-4">
          <div>
            <strong>Full Name:</strong> {accountInfo?.fullName}
          </div>
          <div>
            <strong>Email:</strong> {accountInfo?.username}
          </div>
          <div>
            <strong>Trial:</strong> {accountInfo?.is_trial ? 'Active' : 'Not Started'}
          </div>
          {accountInfo?.trial_ends_at && (
            <div>
              <strong>Trial Ends:</strong> {new Date(accountInfo.trial_ends_at).toLocaleString()}
            </div>
          )}

          <button
            onClick={() => navigate('/delete-account')}
            className="mt-6 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
          >
            Delete Account
          </button>
        </div>
      </motion.section>

      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay:0.2, duration:0.8  }}
        viewport={{ once: true }}
      >
        <div className="bg-white mt-3 border shadow-[0_2px_15px_rgba(0,0,0,0.15)] rounded-md p-6 space-y-4">
          <button className='bg-blue-500 hover:bg-blue-700 text-white p-3 rounded transition' onClick={()=>navigate('/connected-accounts')}>Check connected accounts</button>
        </div>        
      </motion.section>
      
      </div>
  );
}
